import { useUser } from 'contexts/UserEnvironmentContext';
import { isStaff as userIsStaff } from 'utils/userEnvironment';

export function useCurrentUserIsStaff() {
  const { user } = useUser();
  return user ? userIsStaff(user) : false;
}
